import { useEffect, useRef, useState } from "react";
import { useAuth } from "context/AuthContext";
import { formatDateInput2 } from "components/FormatDate";
import notification from "assets/svg/notification.svg";
import avatar from "assets/svg/avatar.svg";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef<any>(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowProfileDropdown(false);
      }
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  return (
    <header className="text-[14px] bg-white border-b-[1px] border-b-[#CCCCCC] w-[calc(100%-268px)] px-[40px] shadow-sm  items-center gap-4 justify-end shadow-3xl h-[10%] z-[30] fixed top-0 right-0 hidden md:flex  ">
      <p className=" text-[#666666] ">{formatDateInput2(new Date())}.</p>
      {/* <button className="relative">
        <img
          src={notification}
          className=" border-r-[2px]  border-r-[#E6E6E6] pr-4 w-[35px] h-[35px] "
          alt="dropdown"
        />
        <div className="w-[12px] h-[12px] rounded-full flex items-center justify-center absolute top-[6px] right-4 bg-primary text-white ">
          <p className="text-[8px] ">1</p>
        </div>
      </button> */}
      <div ref={dropdownRef} className="flex items-center gap-[20px] relative ">
        <div>
          <p className="text-[#333333] text-[14px] ">{user?.firstName}</p>
          <p className="text-[#9EA1AB] text-[12px] ">
            {user?.role === "owner"
              ? "Property Owner"
              : user?.role === "developer"
              ? "Property Developer"
              : user?.role === "admin"
              ? "Admin"
              : ""}
          </p>
        </div>
        <img
          src={user?.profilePicture === "" ? avatar : user.profilePicture}
          className="rounded-full w-10 h-10"
          alt="user"
        />
      </div>
      {/* {showProfileDropdown && (
        <div className="bg-white rounded-[8px] shadow-md font-nunito flex flex-col gap-1  justify-center p-2 absolute top-[60px] right-[25px] z-[30]  items-start  ">
          <button
            onClick={() => {
              navigate("/profile");
              setShowProfileDropdown(false);
            }}
            className="py-1 text-[14px] w-full text-start hover:bg-[#EFEFEF] rounded-[4px] px-3 cursor-pointer "
          >
            Profile
          </button>
          <button
            onClick={() => {
              localStorage.clear();
              navigate("/");
              setShowProfileDropdown(false);
            }}
            className="py-1 text-[14px] w-full text-start hover:bg-[#EFEFEF] rounded-[4px] px-3 cursor-pointer "
          >
            Log out
          </button>
        </div>
      )} */}
    </header>
  );
};

export default Header;
